import React, { Suspense, useEffect } from 'react';
import { observer } from 'mobx-react';
import MainPageLayout from './components/MainPage/MainPageLayout';
import PrivateRoute from './routes/PrivateRoute';
import { publicRoutes, shouldSkipAuthCheck } from './routes/routes';
import { BrowserRouter as Router, Route, Switch, useLocation } from 'react-router-dom';
import LoadingScreen from './components/LoadingScreen';
import { useStore } from './store/rootStore';
import { USER_STATES } from './constants';
import useHandleInactiveTab from './helpers/hooks/useHandleInactiveTab';
import 'antd/dist/antd.min.css';
import 'moment/locale/he';
import 'moment/locale/ro';
import 'moment/locale/uk';
import './App.css';
import './globalStyles.css';
const AppContent = observer(({ theme }) => {
    const { loginStore, appState, setPartnerTheme } = useStore();
    const inactiveTabModal = useHandleInactiveTab();
    const isLoggedIn = loginStore.userState === USER_STATES.LOGGED_IN;
    const location = useLocation();
    useEffect(() => {
        if (!shouldSkipAuthCheck(location.pathname) && loginStore.userState === USER_STATES.UNKNOWN) {
            loginStore.getCurrentUser();
        }
    }, [location.pathname]);
    useEffect(() => {
        if (theme) {
            setPartnerTheme(theme.name);
        }
    }, [theme]);
    if (!shouldSkipAuthCheck(location.pathname) && loginStore.userState === USER_STATES.UNKNOWN) {
        return React.createElement(LoadingScreen, null);
    }
    return (React.createElement(Suspense, { fallback: React.createElement(LoadingScreen, null) },
        React.createElement(Switch, null,
            publicRoutes.map((route) => (React.createElement(Route, { key: route.path, exact: route.exact, path: route.path, component: route.component }))),
            React.createElement(PrivateRoute, { path: "/:section?", component: MainPageLayout, isLoggedIn: isLoggedIn, appState: appState })),
        inactiveTabModal));
});
const App = (props) => {
    return (React.createElement(Router, null,
        React.createElement(AppContent, Object.assign({}, props))));
};
export default App;
